const kebabCase = (string) => {
  return string.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").replace(/--+/g, "-").replace(/[&\\#,+()$~%.'":*?<>{}]/g, "").toLowerCase();
};
const titleCaseWord = (text) => `${text.slice(0, 1).toUpperCase()}${text.slice(1).toLowerCase()}`;
const titleCaseWords = (text) => text.split(" ").map(titleCaseWord).join("");
const titleCaseWordsKeepSpace = (text) => text.split(" ").map(titleCaseWord).join(" ");
const cssClassGenerator = (text) => {
  return titleCaseWords(text).charAt(0).toLowerCase() + titleCaseWords(text).substring(1);
};

export { cssClassGenerator, kebabCase, titleCaseWord, titleCaseWords, titleCaseWordsKeepSpace };
//# sourceMappingURL=stringUtils.js.map
